import { registerQuery } from 'data-fetching-client';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getPublicPhoneNumberV2Rpc } from 'pricing-pages-ui-public-app/__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
const rpcClientNoAuth = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const DEFAULT_PHONE_NUMBER = '1 888 482 7768';
export const GET_PUBLIC_PHONE_NUMBER = registerQuery({
  fieldName: 'publicPhoneNumber',
  args: ['browserLocale', 'preferredCountryCode'],
  fetcher({
    browserLocale,
    preferredCountryCode
  }) {
    return rpcClientNoAuth.call(getPublicPhoneNumberV2Rpc, {
      request: {
        browserLocale,
        preferredCountryCode
      }
    }).then(response => response.phoneNumber || DEFAULT_PHONE_NUMBER).catch(() => DEFAULT_PHONE_NUMBER);
  }
});